import { connect } from "react-redux";
import { actions } from "../../../../../redux/modules/reportes/ventas_por_familia";
import ListadoArticulosVendidosPorFamilia from "./ListadoArticulosVendidosPorFamilia";

const ms2p = (state) => {
    return {
        ...state.reporte_ventas_por_familia,
        usuario: state.usuario.me,
        sucursal_param: state.usuario.sucursal,
    };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(ListadoArticulosVendidosPorFamilia);
